module.exports = __webpack_public_path__ + "img/logo.f2c84249.png";